<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" title="取消订单" :visible.sync="dialogVisible" destroy-on-close width="420px">
		<div>
			<el-form label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<div style="position: relative">
							<i class="el-icon-warning" style="font-size: 24px; color: #e6a23c; position: absolute; top: 0; left: 0"></i>
							<div style="margin-bottom: 10px; margin-left: 30px">
								<p style="color: #475569; font-size: 14px; font-weight: normal; margin: 0; line-height: 22px;margin-bottom: 14px;">请确认取消此订单后，本单商品是否重新加入购物车？</p>
								<el-radio-group v-model="radio">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="2">否</el-radio>
								</el-radio-group>
							</div>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 确定</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import { getConsumerOrderCancel } from '@/api/order/order.js';
import { postConsumerOrderAddCart } from '@/api/order/cart.js';
import { mapActions } from 'vuex';
import Y from '@/utils/Y.js';
export default {
	name: 'DialogCancelOrder',
	props: {
		tradeNo: {
			type: String,
			default: ''
		},
		tradeOrderDetails: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
			radio: 1,
			dialogVisible: false
		};
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
		},

		//取消订单
		async getConsumerOrderCancel(type) {
			await getConsumerOrderCancel(this.tradeNo)
				.then(res => {
					if (type === 1) {
						Y.msg.success('订单商品重新加入购物车 且 订单取消成功！');
					} else {
						Y.msg.success('订单取消成功！');
					}
					this.$emit('confirm');
				})
				.catch(err => {
					Y.msg.error(err.message || '订单取消失败');
				}).finally(() => {
					this.dialogVisible = false;
				});
		},

		//加入购物车
		async postConsumerOrderAddCart() {
			let params = {
			    cartInfo: []
			}
			this.tradeOrderDetails.forEach(item => {
			    params.cartInfo.push({
			        skuId: item.skuId,
			        buyNum: item.buyNum
			    })
			})
			await postConsumerOrderAddCart(params)
				.then(res => {
					// Y.msg.success('商品加入购物车成功！');
						this.getCartList();
					this.getConsumerOrderCancel(1);
					//刷新购物车
				})
				.catch(err => {
					Y.msg.error(err.message || '商品加入购物车失败');
				});
		},

		...mapActions('Cart', ['getCartList']),

		handleConfirm() {
			if (this.radio === 1) {
				// 是
				this.postConsumerOrderAddCart();
			} else {
				// 否
				this.getConsumerOrderCancel(2);
			}
		}
	}
};
</script>

<style lang="less" scoped>
// // 弹出框重置样式
// /deep/ .el-dialog__header {
// 	border-bottom: 1px dashed #e2e8f0;
// 	margin-right: 0;
// 	background: #f8fafc;
// }

// /deep/ .el-dialog__headerbtn .el-dialog__close {
// 	color: #3a434f;
// 	font-size: 24px;
// }

// /deep/ .el-dialog__footer {
// 	border-top: 1px solid #e8e8e8;
// 	padding: 18px;
// }

// /deep/ .el-dialog__body .el-form-item__label {
// 	line-height: 26px;
// }
</style>
